import React from "react";
import "./Notification.css";
import { notification } from "../../interfaces";
const bling = require("./bling.mp3");

interface props {
	hideNotification: (notification: notification) => void;
	activeNotification: notification | null;
	lastNotification: notification | null;
}

export const Notification: React.FC<props> = (props) => {
	const target = props.activeNotification || props.lastNotification;
	return (
		<div className={"notification-area d-flex justify-content-center" + (props.activeNotification ? " active" : "")}>
			<div
				onClick={() => {
					props.hideNotification(target);
				}}
				id="notification"
				className="notification--container"
			>
				<div className="notification--header d-flex flex-row justify-content-between">
					<div className="d-flex flex-row align-items-center">
						<div className={"notification--app-icon " + (target?.platform || "")}></div>
						<h5 className="notification--app-title m-0 ml-2 text-uppercase font-weight-light">{target?.platform || ""}</h5>
					</div>
					<div className="notification--timestamp d-flex flex-row align-items-center">
						<h5 className="m-0 text-lowercase font-weight-bold">lige nu</h5>
					</div>
				</div>
				<div className="notification--app-content">
					<p style={{ fontWeight: 600 }} className="mb-0">
						{target?.from || ""}
					</p>
					<p className="m-0">{target?.desc || "Indsæt beskrivelse her"}</p>
				</div>
			</div>
			{props.activeNotification ? <audio autoPlay src={bling}></audio> : ""}
		</div>
	);
};
